export default class Kamikire {
  get rotation3D(): number {
    return this.theta - Math.PI * 2 * Math.floor(this.theta / (Math.PI * 2))
  }

  set rotation3D(theta: number) {
    this.theta = theta - Math.PI * 2 * Math.floor(theta / (Math.PI * 2))
    const cos = Math.cos(this.theta)
    const sin = Math.sin(this.theta)

    // vector F is the rotated image of (1,0,0);
    const Fx = this.Ax * this.Ax + (this.Bx * this.Bx + this.Cx * this.Cx) * cos
    const Fy =
      this.Ax * this.Ay + (this.Bx * this.By + this.Cx * this.Cy) * cos + (this.Bx * this.Cy - this.Cx * this.By) * sin
    const Gx =
      this.Ax * this.Ay + (this.By * this.Bx + this.Cy * this.Cz) * cos + (this.By * this.Cx - this.Cy * this.Bx) * sin
    const Gy = this.Ay * this.Ay + (this.By * this.By + this.Cy * this.Cy) * cos

    this.ctx.fillStyle = `rgb(${this.r}, ${this.g}, ${this.b})`

    this.ctx.beginPath()
    this.ctx.lineTo(
      this.x + (-Fx * this.size) / 2 + (Gx * this.size) / 2,
      this.y + (-Fy * this.size) / 2 + (Gy * this.size) / 2
    )
    this.ctx.lineTo(
      this.x + (-Fx * this.size) / 2 - (Gx * this.size) / 2,
      this.y + (-Fy * this.size) / 2 - (Gy * this.size) / 2
    )
    this.ctx.lineTo(
      this.x + (Fx * this.size) / 2 - (Gx * this.size) / 2,
      this.y + (Fy * this.size) / 2 - (Gy * this.size) / 2
    )
    this.ctx.lineTo(
      this.x + (Fx * this.size) / 2 + (Gx * this.size) / 2,
      this.y + (Fy * this.size) / 2 + (Gy * this.size) / 2
    )
    this.ctx.closePath()
    this.ctx.fill()
  }

  public size: number
  public x: number
  public y: number

  public r: number
  public g: number
  public b: number
  public alpha: number

  private ctx: any

  private omega: number
  private fallTheta: number
  private fallSpeed: number
  private theta: number

  private Ax: number
  private Ay: number
  private Az: number
  private Bx: number
  private By: number
  private Cx: number
  private Cy: number
  private Cz: number

  constructor(size: number, ctx: any) {
    this.size = size
    this.ctx = ctx

    this.x = 0
    this.y = 0
    this.alpha = 1

    const t = Math.random() * Math.PI * 2
    this.r = Math.floor((1 + Math.cos(t)) * 127.9999)
    this.g = Math.floor((1 + Math.cos(t + (Math.PI * 2) / 3)) * 127.9999)
    this.b = Math.floor((1 + Math.cos(t - (Math.PI * 2) / 3)) * 127.9999)

    this.omega = ((Math.random() * 2 - 1) * Math.PI) / 4
    this.fallTheta = 0
    this.fallSpeed = 1 + Math.random() * 2

    this.theta = Math.random() * Math.PI * 2
    this.Ax = 1
    this.Ay = Math.random()
    this.Az = Math.random() * 2 - 1
    const l = Math.sqrt(this.Ax * this.Ax + this.Ay * this.Ay + this.Az * this.Az)
    this.Ax /= l
    this.Ay /= l
    this.Az /= l
    const s = Math.sqrt(this.Ax * this.Ax + this.Ay * this.Ay)
    if (s === 0) {
      this.Bx = 1.0
      this.By = 0.0
      this.Cx = 0.0
      this.Cy = 1.0
      this.Cz = 0.0
    } else {
      this.Bx = this.Ay
      this.By = -this.Ax
      this.Cx = this.Ax * this.Az
      this.Cy = this.Ay * this.Az
      this.Cz = -(s * s)
      this.Bx /= s
      this.By /= s
      this.Cx /= s * l
      this.Cy /= s * l
      this.Cz /= s * l
    }
  }

  public fall() {
    this.rotation3D = this.rotation3D + this.omega

    this.x += this.fallSpeed * Math.sin(this.fallTheta)
    this.y += this.fallSpeed * Math.cos(this.fallTheta)
    this.fallTheta += ((Math.random() * 2 - 1) * Math.PI) / 12
    if (this.fallTheta < -Math.PI / 2) {
      this.fallTheta = -Math.PI - this.fallTheta
    }
    if (this.fallTheta > Math.PI / 2) {
      this.fallTheta = Math.PI - this.fallTheta
    }
  }
}
